import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.4142 3.58579C21.7893 3.96086 22 4.46957 22 5V17C22 17.5304 21.7893 18.0391 21.4142 18.4142C21.0391 18.7893 20.5304 19 20 19H14.91C14.6477 19.0011 14.3963 19.1053 14.21 19.29L12.72 20.78C12.5795 20.9207 12.3888 20.9998 12.19 21H11.81C11.6112 20.9998 11.4205 20.9207 11.28 20.78L9.79 19.29C9.60374 19.1053 9.35234 19.0011 9.09 19H4C3.46957 19 2.96086 18.7893 2.58579 18.4142C2.21071 18.0391 2 17.5304 2 17V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H20C20.5304 3 21.0391 3.21071 21.4142 3.58579ZM13.8536 13.8536C13.9473 13.7598 14 13.6326 14 13.5V12.5C14 12.3674 13.9473 12.2402 13.8536 12.1464C13.7598 12.0527 13.6326 12 13.5 12H6.5C6.36739 12 6.24021 12.0527 6.14645 12.1464C6.05268 12.2402 6 12.3674 6 12.5V13.5C6 13.6326 6.05268 13.7598 6.14645 13.8536C6.24021 13.9473 6.36739 14 6.5 14H13.5C13.6326 14 13.7598 13.9473 13.8536 13.8536ZM17.8536 9.85355C17.9473 9.75979 18 9.63261 18 9.5V8.5C18 8.36739 17.9473 8.24021 17.8536 8.14645C17.7598 8.05268 17.6326 8 17.5 8H6.5C6.36739 8 6.24021 8.05268 6.14645 8.14645C6.05268 8.24021 6 8.36739 6 8.5V9.5C6 9.63261 6.05268 9.75979 6.14645 9.85355C6.24021 9.94732 6.36739 10 6.5 10H17.5C17.6326 10 17.7598 9.94732 17.8536 9.85355Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgBalloon = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgBalloon;
